export default function getFullRouteFromPath(url: string): string {
    return url.replace(/^\/[a-z]{2}\//, '');
}